import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter032() {
  return <KbChapterPage slug="chapter-032" />;
}

(Chapter032 as unknown as { path: string }).path = "/theory-album/032";
